import { Component, OnInit, Input } from '@angular/core';
import { NodoEntity, FiltrosFormatoAsistencialEntity } from '../../../../services/servicio-formato-asistencial.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-fecha',
  templateUrl: './fecha.component.html',
  styleUrls: ['./fecha.component.css'],
  providers : [DatePipe]
})
export class FechaComponent implements OnInit {

  @Input() nodo: NodoEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;

  titulo: string;
  valor: string;

  constructor( private datePipe: DatePipe) { }

  ngOnInit() {
    if (this.nodo && this.filtros) {
      this.onProcess();
    } else {
      this.titulo = '';
      this.valor = '';
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    if (this.nodo.datos && this.nodo.datos.length > 0) {
      const value = Number(this.nodo.datos[0].valor);
      if (value > 0) {
        this.valor = this.datePipe.transform(value, 'dd/MM/yyyy');
      } else {
        this.valor = '--/--/----';
      }
    } else {
      this.valor = '--/--/----';
    }
    this.onValidateEmptyData();
  }

  onValidateEmptyData(){
    const existData = this.nodo.datos && this.nodo.datos.length > 0;
    if(this.filtros.diligenciados && !existData){
        this.onDelete();
    }
  }

  onDelete(){}

}
